import data from './county-data.json';

const COUNTIES_NAMES = {};
const COUNTIES = {};

data.forEach(country => {
    COUNTIES_NAMES[country.code] = country.name;
    COUNTIES[country.code] = country;
});

export const getCountries = () => COUNTIES_NAMES;

export const getCountryName = code => COUNTIES_NAMES[code] || '';

export const getRegionName = (countryCode, regionCode) => {
    const country = COUNTIES[countryCode];
    if (country && country.regions) {
        const region = country.regions[regionCode];
        if (region) {
            return region;
        }
    }
    return regionCode;
};

export function getCountryRegions(countryCode) {
    const country = COUNTIES[countryCode];
    if (country && country.regions) {
        return { ...country.regions };
    }
    return null;
}
